/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as appV1 from "./keyapis_multiapp_app_v1.pb"

/**
 * Сервис реализует функционал управления партнерами
 */

/**
 * Сервис управления партнерами  для суперапа
 */
export class PartnerServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод сохранения партнера.
   * Поддерживает создание и обновление.
   * Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=664695525.
   * Метод доступен для: admin, manager, service
   */
  PostPartner = (req: PostPartnerRequestDto, init?: RequestInit): Promise<PostPartnerResponseDto> => {
    return fm.request<PostPartnerRequestDto, PostPartnerResponseDto>(`${this.host}/multiapp/api/v1/partner`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения партнера.
   * Метод доступен для: admin, manager, service, ltp_first
   */
  GetPartner = (req: GetPartnerRequestDto, init?: RequestInit): Promise<GetPartnerResponseDto> => {
    return fm.request<GetPartnerRequestDto, GetPartnerResponseDto>(`${this.host}/multiapp/api/v1/partner/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка партнеров.
   * Метод доступен для: admin, manager, service, ltp_first
   */
  GetPartnerList = (req?: GetPartnerListRequestDto, init?: RequestInit): Promise<GetPartnerListResponseDto[]> => {
    return fm.list<GetPartnerListRequestDto, GetPartnerListResponseDto>(`${this.host}/multiapp/api/v1/partner/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества партнеров.
   * Метод доступен для: admin, manager, service, ltp_first
   */
  GetPartnerCount = (req?: GetPartnerCountRequestDto, init?: RequestInit): Promise<GetPartnerCountResponseDto> => {
    return fm.request<GetPartnerCountRequestDto, GetPartnerCountResponseDto>(`${this.host}/multiapp/api/v1/partner/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения токена.
   * Access токен возможно получить только для пользователей с типом master в статусе active, demo и new.
   * Логика работы метода: https://confluence.rt.ru/pages/viewpage.action?pageId=664695865.
   * Не требует авторизации
   */
  GetPartnerToken = (req: GetPartnerTokenRequestDto, init?: RequestInit): Promise<GetPartnerTokenResponseDto> => {
    return fm.request<GetPartnerTokenRequestDto, GetPartnerTokenResponseDto>(`${this.host}/multiapp/api/v1/partner/token${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод обновления публичного ключа партнёра.
   * Поддерживает создание и обновление.
   * Метод доступен для: partner.
   * Требует передачи аутентификационного ключа в заголовке X-API-KEY.
   * Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=664695525
   */
  PostPartnerPublicKey = (req: PostPartnerPublicKeyRequestDto, init?: RequestInit): Promise<PostPartnerPublicKeyResponseDto> => {
    return fm.request<PostPartnerPublicKeyRequestDto, PostPartnerPublicKeyResponseDto>(`${this.host}/multiapp/api/v1/partner/public_key`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления партнёра.
   * Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=804302306.
   * Метод доступен для: admin, manager, service
   */
  DeletePartner = (req: DeletePartnerRequestDto, init?: RequestInit): Promise<DeletePartnerResponseDto> => {
    return fm.request<DeletePartnerRequestDto, DeletePartnerResponseDto>(`${this.host}/multiapp/api/v1/partner/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения адреса дома по ОРПОНу.
   * Адресная строка должны быть в формате \"{Регион}, {Город}, {Улица}, {Дом}, {Строение}\".
   * Партнер может получить адрес только по доступному ему ОРПОНу.
   * Доступные ОРПОНы для партнера может получить через привязанные app в поле app_tags и user_tags.
   * Метод доступен для: admin, manager, service, partner.
   * Роль partner определяется по наличию заголовка X-API-KEY вместо Authorization
   */
  GetPartnerAddressOrpon = (req: GetPartnerAddressOrponRequestDto, init?: RequestInit): Promise<GetPartnerAddressOrponResponseDto> => {
    return fm.request<GetPartnerAddressOrponRequestDto, GetPartnerAddressOrponResponseDto>(`${this.host}/multiapp/api/v1/partner/address/orpon/${encodeURIComponent(req.orpon)}${fm.buildQuery(req, ["orpon"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов направлений сортировки.
 */
export enum PartnerPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type PartnerPagingDirectionTypeResponseEnum = keyof typeof PartnerPagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type PartnerPagingDirectionTypeRequestEnum = Exclude<PartnerPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum PartnerPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * Дата последнего изменения
   */
  CHANGED_AT = "CHANGED_AT",
  /**
   * Дата создания
   */
  CREATED_AT = "CREATED_AT",
  /**
   * По рангу для поиска по тексту.
   * Применяется когда передано поле для поиска по тексту.
   * В случае если текстовое поле не передано, применяется значение по умолчанию
   */
  RANK = "RANK",
}
/**
 * Справочник типов значений сортировки.
 */
export type PartnerPagingOrderByTypeResponseEnum = keyof typeof PartnerPagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type PartnerPagingOrderByTypeRequestEnum = Exclude<PartnerPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос на удаление партнёра
 */
export type DeletePartnerRequestDto = {
  /**
   * Идентификатор партнёра.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос удаления партнёра
 */
export type DeletePartnerResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка при удалении
   */
  readonly error: DeletePartnerResponseErrorDto
}>
/**
 * Ошибка удаления партнёра
 */
export type DeletePartnerResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorRequestDto
  /**
   * У партнера есть хотя бы одно приложение
   */
  readonly linkedAppExists: DeletePartnerResponseErrorLinkedAppExistsRequestDto
}>
/**
 * Ошибка удаления партнёра
 */
export type DeletePartnerResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorResponseDto
  /**
   * У партнера есть хотя бы одно приложение
   */
  readonly linkedAppExists: DeletePartnerResponseErrorLinkedAppExistsDto
}>
/**
 * У партнера есть хотя бы одно приложение
 */
export type DeletePartnerResponseErrorLinkedAppExistsRequestDto = {
}
/**
 * У партнера есть хотя бы одно приложение
 */
export type DeletePartnerResponseErrorLinkedAppExistsDto = {
}
/**
 * Запрос получения адреса по ОРПОНу
 */
export type GetPartnerAddressOrponRequestDto = {
  /**
   * ОРПОН.
   * # Диапазон: 1..9223372036854775807
   */
  orpon: string
}
/**
 * Ответ на запрос получения адреса по ОРПОНу
 */
export type GetPartnerAddressOrponResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Адрес
   */
  readonly data: string
  /**
   * Ошибка
   */
  readonly error: GetPartnerAddressOrponResponseErrorDto
}>
/**
 * Ошибка
 */
export type GetPartnerAddressOrponResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorRequestDto
  /**
   * Доступ запрещен
   */
  readonly permissionDenied: GetPartnerAddressOrponResponseErrorPermissionDeniedRequestDto
}>
/**
 * Ошибка
 */
export type GetPartnerAddressOrponResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorResponseDto
  /**
   * Доступ запрещен
   */
  readonly permissionDenied: GetPartnerAddressOrponResponseErrorPermissionDeniedDto
}>
/**
 * Доступ запрещен.
 * Причины:
 * - У партнера нет разрешения на переданный ОРПОН
 */
export type GetPartnerAddressOrponResponseErrorPermissionDeniedRequestDto = {
}
/**
 * Доступ запрещен.
 * Причины:
 * - У партнера нет разрешения на переданный ОРПОН
 */
export type GetPartnerAddressOrponResponseErrorPermissionDeniedDto = {
}
/**
 * Запрос получения количества партнеров
 */
export type GetPartnerCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: PartnerFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества партнеров
 */
export type GetPartnerCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего партнеров
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetPartnerCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества партнеров
 */
export type GetPartnerCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества партнеров
 */
export type GetPartnerCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения списка партнеров
 */
export type GetPartnerListRequestDto = {
  /**
   * Фильтр
   */
  filter?: PartnerFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: PartnerPagingRequestDto
}>
/**
 * Ответ на запрос получения списка партнеров
 */
export type GetPartnerListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Партнер
   */
  readonly data: PartnerResponseDto
  /**
   * Ошибка
   */
  readonly error: GetPartnerListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка партнеров
 */
export type GetPartnerListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка партнеров
 */
export type GetPartnerListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения партнера
 */
export type GetPartnerRequestDto = {
  /**
   * Идентификатор партнера.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос получения партнера
 */
export type GetPartnerResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Партнер
   */
  readonly data: PartnerResponseDto
  /**
   * Ошибка
   */
  readonly error: GetPartnerResponseErrorDto
}>
/**
 * Ошибка запроса получения партнера
 */
export type GetPartnerResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения партнера
 */
export type GetPartnerResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения токена
 */
export type GetPartnerTokenRequestDto = {
  /**
   * Код.
   * # Тип: Guid
   */
  code: string
  /**
   * Тип ответа.
   * # Допустимые значения: \"id_token\", \"token\", \"id_token token\"
   */
  response: string
  /**
   * Ваучер
   */
  nonce: string
}
/**
 * Ответ на запрос получения токена
 */
export type GetPartnerTokenResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Токен
   */
  readonly data: TokenResponseDto
  /**
   * Ошибка
   */
  readonly error: GetPartnerTokenResponseErrorDto
}>
/**
 * Ошибка
 */
export type GetPartnerTokenResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorRequestDto
  /**
   * Ошибка: пользователь не найден
   */
  readonly userNotFound: GetPartnerTokenResponseErrorUserNotFoundErrorRequestDto
  /**
   * Ошибка: формирования токена
   */
  readonly tokenGenerationError: GetPartnerTokenResponseErrorTokenGenerationErrorRequestDto
  /**
   * Ошибка: некорректный код
   */
  readonly codeNotFoundOrExpiredError: GetPartnerTokenResponseErrorCodeNotFoundOrExpiredErrorRequestDto
  /**
   * Переданный тип ответа не поддерживается
   */
  readonly responseTypeIsNotSupported: GetPartnerTokenResponseErrorResponseTypeIsNotSupportedRequestDto
  /**
   * Доступ запрещен
   */
  readonly permissionDenied: GetPartnerTokenResponseErrorPermissionDeniedRequestDto
}>
/**
 * Ошибка
 */
export type GetPartnerTokenResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorResponseDto
  /**
   * Ошибка: пользователь не найден
   */
  readonly userNotFound: GetPartnerTokenResponseErrorUserNotFoundErrorDto
  /**
   * Ошибка: формирования токена
   */
  readonly tokenGenerationError: GetPartnerTokenResponseErrorTokenGenerationErrorDto
  /**
   * Ошибка: некорректный код
   */
  readonly codeNotFoundOrExpiredError: GetPartnerTokenResponseErrorCodeNotFoundOrExpiredErrorDto
  /**
   * Переданный тип ответа не поддерживается
   */
  readonly responseTypeIsNotSupported: GetPartnerTokenResponseErrorResponseTypeIsNotSupportedDto
  /**
   * Доступ запрещен
   */
  readonly permissionDenied: GetPartnerTokenResponseErrorPermissionDeniedDto
}>
/**
 * Некорректный код.
 * Причины:
 * - Передан неверный код;
 * - Превышен допустимый временной интервал между запросом на формирование кода и запросом на получение идентификационного токена
 */
export type GetPartnerTokenResponseErrorCodeNotFoundOrExpiredErrorRequestDto = {
}
/**
 * Некорректный код.
 * Причины:
 * - Передан неверный код;
 * - Превышен допустимый временной интервал между запросом на формирование кода и запросом на получение идентификационного токена
 */
export type GetPartnerTokenResponseErrorCodeNotFoundOrExpiredErrorDto = {
}
/**
 * Доступ запрещен.
 * Причины:
 * - У запрашивающего приложения нет разрешения на выбранный тип ответа
 */
export type GetPartnerTokenResponseErrorPermissionDeniedRequestDto = {
}
/**
 * Доступ запрещен.
 * Причины:
 * - У запрашивающего приложения нет разрешения на выбранный тип ответа
 */
export type GetPartnerTokenResponseErrorPermissionDeniedDto = {
}
/**
 * Переданный тип ответа не поддерживается
 */
export type GetPartnerTokenResponseErrorResponseTypeIsNotSupportedRequestDto = {
}
/**
 * Переданный тип ответа не поддерживается
 */
export type GetPartnerTokenResponseErrorResponseTypeIsNotSupportedDto = {
}
/**
 * Ошибка формирования токена.
 * Причины:
 * - Ошибка в сервисе KMS.
 * - Ошибка в сервисе Identity
 */
export type GetPartnerTokenResponseErrorTokenGenerationErrorRequestDto = {
}
/**
 * Ошибка формирования токена.
 * Причины:
 * - Ошибка в сервисе KMS.
 * - Ошибка в сервисе Identity
 */
export type GetPartnerTokenResponseErrorTokenGenerationErrorDto = {
}
/**
 * Данные пользователя для формирования идентификационного токена не найдены.
 * Причины:
 * - Пользователь с таким идентификатором отсутсвует в БД ключа;
 * - Ошибка взаимодействия с сервисом Домохозяйств
 */
export type GetPartnerTokenResponseErrorUserNotFoundErrorRequestDto = {
}
/**
 * Данные пользователя для формирования идентификационного токена не найдены.
 * Причины:
 * - Пользователь с таким идентификатором отсутсвует в БД ключа;
 * - Ошибка взаимодействия с сервисом Домохозяйств
 */
export type GetPartnerTokenResponseErrorUserNotFoundErrorDto = {
}
/**
 * Идентификационный токен
 */
export type IdTokenPayloadRequestDto = {
  /**
   * Идентификатор токена
   */
  jti: string
  /**
   * Ваучер
   */
  nonce: string
  /**
   * Идентификатор пользователя, для которого выдан токен
   */
  sub: string
  /**
   * Роль
   */
  role?: string | null
  /**
   * Номер телефона
   */
  phoneNumber?: string | null
  /**
   * Электронная почта
   */
  email?: string | null
  /**
   * Идентифкатор ОРПОН
   */
  orpon?: string | null
  /**
   * Номер квартиры
   */
  room?: string | null
  /**
   * Идентифкатор компании
   */
  companyId?: string | null
  /**
   * Наименование компании
   */
  companyName?: string | null
  /**
   * Время авторизации пользователя unix timestamp
   */
  authTime: string
  /**
   * Срок истечения действия токен unix timestamp
   */
  exp: string
  /**
   * Сервис, выдавший токен
   */
  iss: string
  /**
   * Url сервиса, для которого выпустили токен
   */
  aud: string
  /**
   * Идентификатор приложения партнёра
   */
  appId: string
  /**
   * КЛАДР
   */
  kladrId?: string | null
}
/**
 * Идентификационный токен
 */
export type IdTokenPayloadResponseDto = {
  /**
   * Идентификатор токена
   */
  jti: string
  /**
   * Ваучер
   */
  nonce: string
  /**
   * Идентификатор пользователя, для которого выдан токен
   */
  sub: string
  /**
   * Роль
   */
  role: string | null
  /**
   * Номер телефона
   */
  phoneNumber: string | null
  /**
   * Электронная почта
   */
  email: string | null
  /**
   * Идентифкатор ОРПОН
   */
  orpon: string | null
  /**
   * Номер квартиры
   */
  room: string | null
  /**
   * Идентифкатор компании
   */
  companyId: string | null
  /**
   * Наименование компании
   */
  companyName: string | null
  /**
   * Время авторизации пользователя unix timestamp
   */
  authTime: string
  /**
   * Срок истечения действия токен unix timestamp
   */
  exp: string
  /**
   * Сервис, выдавший токен
   */
  iss: string
  /**
   * Url сервиса, для которого выпустили токен
   */
  aud: string
  /**
   * Идентификатор приложения партнёра
   */
  appId: string
  /**
   * КЛАДР
   */
  kladrId: string | null
}
/**
 * Партнер.
 * # Описание модели
 */
export type PartnerRequestDto = {
  /**
   * Идентификатор.
   * Если не передан создаётся сервером.
   * # Тип: Guid
   */
  id?: string
  /**
   * Наименование.
   * # Диапазон: 2..256
   */
  name: string
  /**
   * API ключ.
   * # Тип: Guid?
   */
  apiKey: string
  /**
   * Дата обновления партнера.
   * # Тип: DateTime
   */
  changedAt?: string | null
}
/**
 * Партнер.
 * # Описание модели
 */
export type PartnerResponseDto = {
  /**
   * Идентификатор.
   * Если не передан создаётся сервером.
   * # Тип: Guid
   */
  id: string
  /**
   * Наименование.
   * # Диапазон: 2..256
   */
  name: string
  /**
   * Публичный ключ
   */
  readonly publicKey: string | null
  /**
   * Дата создания партнера.
   * # Тип: DateTime
   */
  readonly createdAt: string
  /**
   * Дата обновления партнера.
   * # Тип: DateTime
   */
  changedAt: string
  /**
   * Дата удаления партнера.
   * # Тип: DateTime?
   */
  readonly deletedAt: string | null
  /**
   * Хэш от API ключа
   */
  readonly apiKeyHash: string | null
  /**
   * API ключ маскированный
   */
  readonly apiKeyMasked: string | null
}
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type PartnerSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: PartnerSavingErrorConflictRequestDto
  /**
   * API-key уже существует
   */
  readonly apiKeyExists: PartnerSavingErrorApiKeyExistsRequestDto
  /**
   * Партнёр удалён
   */
  readonly partnerIsDeleted: PartnerSavingErrorPartnerIsDeletedRequestDto
}>
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type PartnerSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: PartnerSavingErrorConflictResponseDto
  /**
   * API-key уже существует
   */
  readonly apiKeyExists: PartnerSavingErrorApiKeyExistsResponseDto
  /**
   * Партнёр удалён
   */
  readonly partnerIsDeleted: PartnerSavingErrorPartnerIsDeletedResponseDto
}>
/**
 * API-key уже существует.
 * Может появиться только в случае создания партнера.
 * Причины:
 * - В базе уже хранится такой api_key, он должен быть уникален для каждого партнера
 */
export type PartnerSavingErrorApiKeyExistsRequestDto = {
}
/**
 * API-key уже существует.
 * Может появиться только в случае создания партнера.
 * Причины:
 * - В базе уже хранится такой api_key, он должен быть уникален для каждого партнера
 */
export type PartnerSavingErrorApiKeyExistsResponseDto = {
}
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at отличаются
 */
export type PartnerSavingErrorConflictRequestDto = {
}
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at отличаются
 */
export type PartnerSavingErrorConflictResponseDto = {
}
/**
 * Партнёр удалён.
 * Причины:
 * - Переданный публичный ключ принадлежит удалённому партнеру
 */
export type PartnerSavingErrorPartnerIsDeletedRequestDto = {
}
/**
 * Партнёр удалён.
 * Причины:
 * - Переданный публичный ключ принадлежит удалённому партнеру
 */
export type PartnerSavingErrorPartnerIsDeletedResponseDto = {
}
/**
 * Фильтр партнеров
 */
export type PartnerFilterRequestDto = {
  /**
   * По тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование
   */
  text?: string | null
  /**
   * От даты обновления партнера включительно (больше или равно)
   */
  beginChangedAt?: string | null
  /**
   * До даты обновления партнера (меньше)
   */
  endChangedAt?: string | null
  /**
   * По идентификаторам доступных шаблонов.
   * # Тип: Guid
   */
  templateIds?: string[]
  /**
   * Показывать удаленные
   */
  isShowDeleted?: boolean | null
}
/**
 * Фильтр партнеров
 */
export type PartnerFilterResponseDto = {
  /**
   * По тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование
   */
  text: string | null
  /**
   * От даты обновления партнера включительно (больше или равно)
   */
  beginChangedAt: string | null
  /**
   * До даты обновления партнера (меньше)
   */
  endChangedAt: string | null
  /**
   * По идентификаторам доступных шаблонов.
   * # Тип: Guid
   */
  templateIds: string[]
  /**
   * Показывать удаленные
   */
  isShowDeleted: boolean | null
}
/**
 * Пагинация партнеров
 */
export type PartnerPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType?: PartnerPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: PartnerPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Пагинация партнеров
 */
export type PartnerPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType: PartnerPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: PartnerPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Запрос сохранения публичного ключа партнера
 */
export type PostPartnerPublicKeyRequestDto = {
  /**
   * Публичный ключ
   */
  publicKey: string
}
/**
 * Ответ на запрос сохранения публичного ключа партнера
 */
export type PostPartnerPublicKeyResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Партнер
   */
  readonly data: PartnerResponseDto
  /**
   * Ошибка
   */
  readonly error: PostPartnerPublicKeyResponseErrorDto
}>
/**
 * Ошибка запроса сохранения публичного ключа партнера
 */
export type PostPartnerPublicKeyResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: PartnerSavingErrorRequestDto
}>
/**
 * Ошибка запроса сохранения публичного ключа партнера
 */
export type PostPartnerPublicKeyResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: PartnerSavingErrorResponseDto
}>
/**
 * Запрос сохранения партнера
 */
export type PostPartnerRequestDto = {
  /**
   * Партнер
   */
  data: PartnerRequestDto
}
/**
 * Ответ на запрос сохранения партнера
 */
export type PostPartnerResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Партнер
   */
  readonly data: PartnerResponseDto
  /**
   * Ошибка
   */
  readonly error: PostPartnerResponseErrorDto
}>
/**
 * Ошибка запроса сохранения партнера
 */
export type PostPartnerResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: PartnerSavingErrorRequestDto
  /**
   * Api-Key обязателен при создании партнера
   */
  readonly missingApiKeyOnCreation: PostPartnerResponseErrorMissingApiKeyOnCreationRequestDto
}>
/**
 * Ошибка запроса сохранения партнера
 */
export type PostPartnerResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: PartnerSavingErrorResponseDto
  /**
   * Api-Key обязателен при создании партнера
   */
  readonly missingApiKeyOnCreation: PostPartnerResponseErrorMissingApiKeyOnCreationDto
}>
/**
 * Api-Key обязателен при создании партнера
 */
export type PostPartnerResponseErrorMissingApiKeyOnCreationRequestDto = {
}
/**
 * Api-Key обязателен при создании партнера
 */
export type PostPartnerResponseErrorMissingApiKeyOnCreationDto = {
}
/**
 * Ответ на запрос токена
 */
export type TokenRequestDto = {
}
/**
 * Ответ на запрос токена
 */
export type TokenResponseDto = {
  /**
   * ID токен в формате nested JWT
   */
  readonly idToken: string
  /**
   * Авторизационный токен
   */
  readonly accessToken: string
  /**
   * Тип авторизационного токена
   */
  readonly typeOfAccessToken: string
  /**
   * Токен, используемый для получения нового Access Token после истечения срока действия текущего токена доступа
   */
  readonly refreshToken: string
  /**
   * Время (в секундах), через которое истечет срок действия Access Token
   */
  readonly expiresIn: number
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос на удаление партнёра
   */
  "DeletePartnerRequest": {
    "kind": "class",
    "text": "Запрос на удаление партнёра",
    "fields": {
      /**
       * Идентификатор партнёра.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор партнёра.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления партнёра
   */
  "DeletePartnerResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления партнёра",
    "fields": {
      /**
       * Ошибка при удалении
       */
      "error": {
        "type": "DeletePartnerResponse.Error",
        "text": "Ошибка при удалении",
      },
    },
  },
  /**
   * Ошибка удаления партнёра
   */
  "DeletePartnerResponse.Error": {
    "kind": "class",
    "text": "Ошибка удаления партнёра",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * У партнера есть хотя бы одно приложение
       */
      "linkedAppExists": {
        "type": "DeletePartnerResponse.Error.LinkedAppExists",
        "text": "У партнера есть хотя бы одно приложение",
      },
    },
  },
  /**
   * У партнера есть хотя бы одно приложение
   */
  "DeletePartnerResponse.Error.LinkedAppExists": {
    "kind": "class",
    "text": "У партнера есть хотя бы одно приложение",
  },
  /**
   * Запрос получения адреса по ОРПОНу
   */
  "GetPartnerAddressOrponRequest": {
    "kind": "class",
    "text": "Запрос получения адреса по ОРПОНу",
    "fields": {
      /**
       * ОРПОН.
       * # Диапазон: 1..9223372036854775807
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН.\n# Диапазон: 1..9223372036854775807",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 9223372036854775807,
            "message": "Значение не входит в допустимый диапазон. Максимум: 9223372036854775807"
          },
        }
      },
    },
  },
  /**
   * Ответ на запрос получения адреса по ОРПОНу
   */
  "GetPartnerAddressOrponResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения адреса по ОРПОНу",
    "fields": {
      /**
       * Адрес
       */
      "data": {
        "type": "string",
        "text": "Адрес",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetPartnerAddressOrponResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "GetPartnerAddressOrponResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Доступ запрещен
       */
      "permissionDenied": {
        "type": "GetPartnerAddressOrponResponse.Error.PermissionDenied",
        "text": "Доступ запрещен",
      },
    },
  },
  /**
   * Доступ запрещен.
   * Причины:
   * - У партнера нет разрешения на переданный ОРПОН
   */
  "GetPartnerAddressOrponResponse.Error.PermissionDenied": {
    "kind": "class",
    "text": "Доступ запрещен.\nПричины:\n- У партнера нет разрешения на переданный ОРПОН",
  },
  /**
   * Запрос получения количества партнеров
   */
  "GetPartnerCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества партнеров",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "PartnerFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества партнеров
   */
  "GetPartnerCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества партнеров",
    "fields": {
      /**
       * Всего партнеров
       */
      "data": {
        "type": "int32",
        "text": "Всего партнеров",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetPartnerCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества партнеров
   */
  "GetPartnerCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества партнеров",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения списка партнеров
   */
  "GetPartnerListRequest": {
    "kind": "class",
    "text": "Запрос получения списка партнеров",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "PartnerFilter",
        "text": "Фильтр",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "PartnerPaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка партнеров
   */
  "GetPartnerListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка партнеров",
    "fields": {
      /**
       * Партнер
       */
      "data": {
        "type": "Partner",
        "text": "Партнер",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetPartnerListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка партнеров
   */
  "GetPartnerListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка партнеров",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения партнера
   */
  "GetPartnerRequest": {
    "kind": "class",
    "text": "Запрос получения партнера",
    "fields": {
      /**
       * Идентификатор партнера.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор партнера.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения партнера
   */
  "GetPartnerResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения партнера",
    "fields": {
      /**
       * Партнер
       */
      "data": {
        "type": "Partner",
        "text": "Партнер",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetPartnerResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения партнера
   */
  "GetPartnerResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения партнера",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения токена
   */
  "GetPartnerTokenRequest": {
    "kind": "class",
    "text": "Запрос получения токена",
    "fields": {
      /**
       * Код.
       * # Тип: Guid
       */
      "code": {
        "type": "string",
        "text": "Код.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип ответа.
       * # Допустимые значения: \"id_token\", \"token\", \"id_token token\"
       */
      "response": {
        "type": "string",
        "text": "Тип ответа.\n# Допустимые значения: \"id_token\", \"token\", \"id_token token\"",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ваучер
       */
      "nonce": {
        "type": "string",
        "text": "Ваучер",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения токена
   */
  "GetPartnerTokenResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения токена",
    "fields": {
      /**
       * Токен
       */
      "data": {
        "type": "Token",
        "text": "Токен",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetPartnerTokenResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "GetPartnerTokenResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка: пользователь не найден
       */
      "userNotFound": {
        "type": "GetPartnerTokenResponse.Error.UserNotFoundError",
        "text": "Ошибка: пользователь не найден",
      },
      /**
       * Ошибка: формирования токена
       */
      "tokenGenerationError": {
        "type": "GetPartnerTokenResponse.Error.TokenGenerationError",
        "text": "Ошибка: формирования токена",
      },
      /**
       * Ошибка: некорректный код
       */
      "codeNotFoundOrExpiredError": {
        "type": "GetPartnerTokenResponse.Error.CodeNotFoundOrExpiredError",
        "text": "Ошибка: некорректный код",
      },
      /**
       * Переданный тип ответа не поддерживается
       */
      "responseTypeIsNotSupported": {
        "type": "GetPartnerTokenResponse.Error.ResponseTypeIsNotSupported",
        "text": "Переданный тип ответа не поддерживается",
      },
      /**
       * Доступ запрещен
       */
      "permissionDenied": {
        "type": "GetPartnerTokenResponse.Error.PermissionDenied",
        "text": "Доступ запрещен",
      },
    },
  },
  /**
   * Некорректный код.
   * Причины:
   * - Передан неверный код;
   * - Превышен допустимый временной интервал между запросом на формирование кода и запросом на получение идентификационного токена
   */
  "GetPartnerTokenResponse.Error.CodeNotFoundOrExpiredError": {
    "kind": "class",
    "text": "Некорректный код.\nПричины:\n- Передан неверный код;\n- Превышен допустимый временной интервал между запросом на формирование кода и запросом на получение идентификационного токена",
  },
  /**
   * Доступ запрещен.
   * Причины:
   * - У запрашивающего приложения нет разрешения на выбранный тип ответа
   */
  "GetPartnerTokenResponse.Error.PermissionDenied": {
    "kind": "class",
    "text": "Доступ запрещен.\nПричины:\n- У запрашивающего приложения нет разрешения на выбранный тип ответа",
  },
  /**
   * Переданный тип ответа не поддерживается
   */
  "GetPartnerTokenResponse.Error.ResponseTypeIsNotSupported": {
    "kind": "class",
    "text": "Переданный тип ответа не поддерживается",
  },
  /**
   * Ошибка формирования токена.
   * Причины:
   * - Ошибка в сервисе KMS.
   * - Ошибка в сервисе Identity
   */
  "GetPartnerTokenResponse.Error.TokenGenerationError": {
    "kind": "class",
    "text": "Ошибка формирования токена.\nПричины:\n- Ошибка в сервисе KMS.\n- Ошибка в сервисе Identity",
  },
  /**
   * Данные пользователя для формирования идентификационного токена не найдены.
   * Причины:
   * - Пользователь с таким идентификатором отсутсвует в БД ключа;
   * - Ошибка взаимодействия с сервисом Домохозяйств
   */
  "GetPartnerTokenResponse.Error.UserNotFoundError": {
    "kind": "class",
    "text": "Данные пользователя для формирования идентификационного токена не найдены.\nПричины:\n- Пользователь с таким идентификатором отсутсвует в БД ключа;\n- Ошибка взаимодействия с сервисом Домохозяйств",
  },
  /**
   * Идентификационный токен
   */
  "IdTokenPayload": {
    "kind": "class",
    "text": "Идентификационный токен",
    "fields": {
      /**
       * Идентификатор токена
       */
      "jti": {
        "type": "string",
        "text": "Идентификатор токена",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ваучер
       */
      "nonce": {
        "type": "string",
        "text": "Ваучер",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор пользователя, для которого выдан токен
       */
      "sub": {
        "type": "string",
        "text": "Идентификатор пользователя, для которого выдан токен",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Роль
       */
      "role": {
        "type": "google.protobuf.StringValue",
        "text": "Роль",
      },
      /**
       * Номер телефона
       */
      "phoneNumber": {
        "type": "google.protobuf.StringValue",
        "text": "Номер телефона",
      },
      /**
       * Электронная почта
       */
      "email": {
        "type": "google.protobuf.StringValue",
        "text": "Электронная почта",
      },
      /**
       * Идентифкатор ОРПОН
       */
      "orpon": {
        "type": "google.protobuf.StringValue",
        "text": "Идентифкатор ОРПОН",
      },
      /**
       * Номер квартиры
       */
      "room": {
        "type": "google.protobuf.StringValue",
        "text": "Номер квартиры",
      },
      /**
       * Идентифкатор компании
       */
      "companyId": {
        "type": "google.protobuf.StringValue",
        "text": "Идентифкатор компании",
      },
      /**
       * Наименование компании
       */
      "companyName": {
        "type": "google.protobuf.StringValue",
        "text": "Наименование компании",
      },
      /**
       * Время авторизации пользователя unix timestamp
       */
      "authTime": {
        "type": "string",
        "text": "Время авторизации пользователя unix timestamp",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Срок истечения действия токен unix timestamp
       */
      "exp": {
        "type": "string",
        "text": "Срок истечения действия токен unix timestamp",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Сервис, выдавший токен
       */
      "iss": {
        "type": "string",
        "text": "Сервис, выдавший токен",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Url сервиса, для которого выпустили токен
       */
      "aud": {
        "type": "string",
        "text": "Url сервиса, для которого выпустили токен",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор приложения партнёра
       */
      "appId": {
        "type": "string",
        "text": "Идентификатор приложения партнёра",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * КЛАДР
       */
      "kladrId": {
        "type": "google.protobuf.StringValue",
        "text": "КЛАДР",
      },
    },
  },
  /**
   * Партнер.
   * # Описание модели
   */
  "Partner": {
    "kind": "class",
    "text": "Партнер.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор.
       * Если не передан создаётся сервером.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\nЕсли не передан создаётся сервером.\n# Тип: Guid",
      },
      /**
       * Наименование.
       * # Диапазон: 2..256
       */
      "name": {
        "type": "string",
        "text": "Наименование.\n# Диапазон: 2..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 2,
            "message": "Значение не входит в допустимый диапазон. Минимум: 2"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * API ключ.
       * # Тип: Guid?
       */
      "apiKey": {
        "type": "google.protobuf.StringValue",
        "text": "API ключ.\n# Тип: Guid?",
      },
      /**
       * Публичный ключ
       */
      "publicKey": {
        "type": "google.protobuf.StringValue",
        "text": "Публичный ключ",
      },
      /**
       * Дата создания партнера.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания партнера.\n# Тип: DateTime",
      },
      /**
       * Дата обновления партнера.
       * # Тип: DateTime
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата обновления партнера.\n# Тип: DateTime",
      },
      /**
       * Дата удаления партнера.
       * # Тип: DateTime?
       */
      "deletedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата удаления партнера.\n# Тип: DateTime?",
      },
      /**
       * Хэш от API ключа
       */
      "apiKeyHash": {
        "type": "google.protobuf.StringValue",
        "text": "Хэш от API ключа",
      },
      /**
       * API ключ маскированный
       */
      "apiKeyMasked": {
        "type": "google.protobuf.StringValue",
        "text": "API ключ маскированный",
      },
    },
  },
  /**
   * Ошибка сохранения.
   * Эти проверки выполняются при работе с базой данных и сторонними сервисами
   */
  "Partner.SavingError": {
    "kind": "class",
    "text": "Ошибка сохранения.\nЭти проверки выполняются при работе с базой данных и сторонними сервисами",
    "fields": {
      /**
       * Конфликт версий
       */
      "conflict": {
        "type": "Partner.SavingError.Conflict",
        "text": "Конфликт версий",
      },
      /**
       * API-key уже существует
       */
      "apiKeyExists": {
        "type": "Partner.SavingError.ApiKeyExists",
        "text": "API-key уже существует",
      },
      /**
       * Партнёр удалён
       */
      "partnerIsDeleted": {
        "type": "Partner.SavingError.PartnerIsDeleted",
        "text": "Партнёр удалён",
      },
    },
  },
  /**
   * API-key уже существует.
   * Может появиться только в случае создания партнера.
   * Причины:
   * - В базе уже хранится такой api_key, он должен быть уникален для каждого партнера
   */
  "Partner.SavingError.ApiKeyExists": {
    "kind": "class",
    "text": "API-key уже существует.\nМожет появиться только в случае создания партнера.\nПричины:\n- В базе уже хранится такой api_key, он должен быть уникален для каждого партнера",
  },
  /**
   * Конфликт версий.
   * Причины:
   * - В базе хранится другая версия строки, значения changed_at отличаются
   */
  "Partner.SavingError.Conflict": {
    "kind": "class",
    "text": "Конфликт версий.\nПричины:\n- В базе хранится другая версия строки, значения changed_at отличаются",
  },
  /**
   * Партнёр удалён.
   * Причины:
   * - Переданный публичный ключ принадлежит удалённому партнеру
   */
  "Partner.SavingError.PartnerIsDeleted": {
    "kind": "class",
    "text": "Партнёр удалён.\nПричины:\n- Переданный публичный ключ принадлежит удалённому партнеру",
  },
  /**
   * Фильтр партнеров
   */
  "PartnerFilter": {
    "kind": "class",
    "text": "Фильтр партнеров",
    "fields": {
      /**
       * По тексту.
       * Если значение не передано то поиск по нему не производится.
       * # Диапазон: 3..64.
       * # Поиск производится по полям:
       * # - Наименование
       */
      "text": {
        "type": "google.protobuf.StringValue",
        "text": "По тексту.\nЕсли значение не передано то поиск по нему не производится.\n# Диапазон: 3..64.\n# Поиск производится по полям:\n# - Наименование",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * От даты обновления партнера включительно (больше или равно)
       */
      "beginChangedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "От даты обновления партнера включительно (больше или равно)",
      },
      /**
       * До даты обновления партнера (меньше)
       */
      "endChangedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "До даты обновления партнера (меньше)",
      },
      /**
       * По идентификаторам доступных шаблонов.
       * # Тип: Guid
       */
      "templateIds": {
        "type": "string",
        "text": "По идентификаторам доступных шаблонов.\n# Тип: Guid",
      },
      /**
       * Показывать удаленные
       */
      "isShowDeleted": {
        "type": "google.protobuf.BoolValue",
        "text": "Показывать удаленные",
      },
    },
  },
  /**
   * Пагинация партнеров
   */
  "PartnerPaging": {
    "kind": "class",
    "text": "Пагинация партнеров",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: CHANGED_AT
       */
      "orderByType": {
        "type": "PartnerPaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: CHANGED_AT",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "PartnerPaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Запрос сохранения публичного ключа партнера
   */
  "PostPartnerPublicKeyRequest": {
    "kind": "class",
    "text": "Запрос сохранения публичного ключа партнера",
    "fields": {
      /**
       * Публичный ключ
       */
      "publicKey": {
        "type": "string",
        "text": "Публичный ключ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения публичного ключа партнера
   */
  "PostPartnerPublicKeyResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения публичного ключа партнера",
    "fields": {
      /**
       * Партнер
       */
      "data": {
        "type": "Partner",
        "text": "Партнер",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostPartnerPublicKeyResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения публичного ключа партнера
   */
  "PostPartnerPublicKeyResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения публичного ключа партнера",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "Partner.SavingError",
        "text": "Ошибка сохранения",
      },
    },
  },
  /**
   * Запрос сохранения партнера
   */
  "PostPartnerRequest": {
    "kind": "class",
    "text": "Запрос сохранения партнера",
    "fields": {
      /**
       * Партнер
       */
      "data": {
        "type": "Partner",
        "text": "Партнер",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения партнера
   */
  "PostPartnerResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения партнера",
    "fields": {
      /**
       * Партнер
       */
      "data": {
        "type": "Partner",
        "text": "Партнер",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostPartnerResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения партнера
   */
  "PostPartnerResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения партнера",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "Partner.SavingError",
        "text": "Ошибка сохранения",
      },
      /**
       * Api-Key обязателен при создании партнера
       */
      "missingApiKeyOnCreation": {
        "type": "PostPartnerResponse.Error.MissingApiKeyOnCreation",
        "text": "Api-Key обязателен при создании партнера",
      },
    },
  },
  /**
   * Api-Key обязателен при создании партнера
   */
  "PostPartnerResponse.Error.MissingApiKeyOnCreation": {
    "kind": "class",
    "text": "Api-Key обязателен при создании партнера",
  },
  /**
   * Ответ на запрос токена
   */
  "Token": {
    "kind": "class",
    "text": "Ответ на запрос токена",
    "fields": {
      /**
       * ID токен в формате nested JWT
       */
      "idToken": {
        "type": "string",
        "text": "ID токен в формате nested JWT",
      },
      /**
       * Авторизационный токен
       */
      "accessToken": {
        "type": "string",
        "text": "Авторизационный токен",
      },
      /**
       * Тип авторизационного токена
       */
      "typeOfAccessToken": {
        "type": "string",
        "text": "Тип авторизационного токена",
      },
      /**
       * Токен, используемый для получения нового Access Token после истечения срока действия текущего токена доступа
       */
      "refreshToken": {
        "type": "string",
        "text": "Токен, используемый для получения нового Access Token после истечения срока действия текущего токена доступа",
      },
      /**
       * Время (в секундах), через которое истечет срок действия Access Token
       */
      "expiresIn": {
        "type": "int32",
        "text": "Время (в секундах), через которое истечет срок действия Access Token",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "PartnerPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "PartnerPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Дата последнего изменения
       */
      "CHANGED_AT": {
        "i": 1,
        "text": "Дата последнего изменения",
      },
      /**
       * Дата создания
       */
      "CREATED_AT": {
        "i": 2,
        "text": "Дата создания",
      },
      /**
       * По рангу для поиска по тексту.
       * Применяется когда передано поле для поиска по тексту.
       * В случае если текстовое поле не передано, применяется значение по умолчанию
       */
      "RANK": {
        "i": 3,
        "text": "По рангу для поиска по тексту.\nПрименяется когда передано поле для поиска по тексту.\nВ случае если текстовое поле не передано, применяется значение по умолчанию",
      },
    },
  },
}